import React from 'react';
import Container from '@material-ui/core/Container';

const PasswordReset = () => {
  return (
    <Container component="main" maxWidth="xs">
      Pass Reset
    </Container>
  );
};

export default PasswordReset;
